import axios from 'axios'
import { URL, apiToken, authToken } from './auth.env'

const authAxiosInstaceV1 = axios.create({
  baseURL: `${URL}/api/v1`,
  headers: {
    'api-token': apiToken
  },
  withCredentials: true
})
authAxiosInstaceV1.interceptors.response.use(function (response) {
  if (response.data.redirect_to) {
    location.href = response.data.redirect_to
  }
  return response
})
export const AuthAPI = {

  /**
   * Login user with Email and Password
   * @param {string} [data={ email: '', password: '' }]
   * @returns {Promise}
   */
  login (data = { email: '', password: '' }) {
    return authAxiosInstaceV1({
      method: 'post',
      data: data,
      url: `/auth/login/local/`,
      headers: {
        'api-token': apiToken
      }
    })
  },
  /**
   *
   * Login user with userToken
   * @param {*} token
   * @returns
   */
  loginWithToken (token) {
    return authAxiosInstaceV1({
      method: 'get',
      url: `/users/profile`,
      headers: {
        'auth-token': token,
        'api-token': apiToken
      }
    })
  },
  /**
   * Call to get list of user businesses
   *
   * @returns {Promise}
   */
  getUserBusinesses () {
    return authAxiosInstaceV1({
      method: 'get',
      url: '/users/businesses',
      headers: {
        'auth-token': authToken(),
        'api-token': apiToken
      }
    })
  },
  /**
   * Call to set users active business
   *
   * @param {*} businessId
   * @returns {Promise}
   */
  setActiveBusiness (businessId) {
    return authAxiosInstaceV1({
      method: 'patch',
      url: `/users/businesses/${businessId}`,
      headers: {
        'auth-token': authToken(),
        'api-token': apiToken
      }
    })
  },
  /**
   *  Call to get a business by id
   *
   * @returns {Promise}
   */
  getBusinessById (businessId) {
    return authAxiosInstaceV1({
      method: 'get',
      url: `/businesses/${businessId}`,
      headers: {
        'auth-token': authToken(),
        'api-token': apiToken
      }
    })
  },
  loginWithGoogle (googleToken) {
    return authAxiosInstaceV1({
      method: 'POST',
      url: `/auth/login/google`,
      headers: {
        'api-token': apiToken
      },
      data: { google_auth_token: googleToken }
    })
  },
  requestForgotPassword (data) {
    return authAxiosInstaceV1({
      method: 'POST',
      url: `/auth/passwords/reset/request`,
      headers: {
        'api-token': apiToken
      },
      data
    })
  },
  verifyInvitationToken (invitation) {
    return authAxiosInstaceV1({
      method: 'GET',
      url: `/invitations/${invitation}/verify`
    })
  },
  resetPassword (resetToken, data) {
    return authAxiosInstaceV1({
      method: 'POST',
      url: `/auth/passwords/reset/${resetToken}`,
      headers: {
        'api-token': apiToken
      },
      data
    })
  },
  acceptInvitation (invId, data) {
    return authAxiosInstaceV1({
      method: 'PATCH',
      url: `/invitations/${invId}/accept`,
      headers: {
        'api-token': apiToken
      },
      data
    })
  },
  verify () {
    return authAxiosInstaceV1({
      method: 'GET',
      url: `/auth/verify`,
      headers: {
        'api-token': apiToken
      }
    })
  },
  verifyAuthCode (code, token) {
    return authAxiosInstaceV1({
      method: 'POST',
      url: `/auth/verify/two_factor`,
      headers: {
        'api-token': apiToken,
        'auth-token': token || authToken()
      },
      data: {
        'auth_code': code
      }
    })
  },
  resendAuthCode (token) {
    return authAxiosInstaceV1({
      method: 'GET',
      url: `/auth/two_factor`,
      headers: {
        'api-token': apiToken,
        'auth-token': token || authToken()
      }
    })
  }

}
